"use client";

import React, { useState, useEffect } from "react";
import styles from "./index.module.css";
import { Button } from "antd";
import Image from "next/image";
import { useRouter } from "next/navigation";
import StartBuildingButton from "@/components/Home/Hero/StartBuildingButton";

const Hero = () => {
  const router = useRouter();
  const integrationReadyText = "Integration-ready API";
  const h1Text = "Automated workflows for";
  const rotatingKeywords = ["driver's license verification"];
  const [h1HighlightText, setH1HighlightText] = useState(rotatingKeywords[0]);
  const h1PoweredByText = "powered by AI";
  const descriptionText =
    "VeriID helps businesses verify driver’s licenses with AI — fast, accurate, and fully privacy-first.";
  const playgroundButtonText = "Try in Playground";
  const subtitleText = "Instant Image Screening";
  const h2Text = "Built for accuracy, speed, and security";
  const advantage1Value = "10×";
  const advantage1Description = "Faster submission and review process";
  const advantage2Value = "↓70%";
  const advantage2Description =
    "Lower ID verification costs with early image filtering";
  const advantage3Value = "240ms";
  const advantage3Description = "Average detection speed per request";

  useEffect(() => {
    const interval = setInterval(() => {
      setH1HighlightText((prevText) => {
        const currentIndex = rotatingKeywords.indexOf(prevText);
        const nextIndex = (currentIndex + 1) % rotatingKeywords.length;
        return rotatingKeywords[nextIndex];
      });
    }, 2500); // Change keyword every 2.5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className={styles.background}>
        <section className={styles.section}>
          <div className={styles.hero}>
            <div className={styles.content}>
              <div className={styles.integrationReady}>
                <Image
                  src="/images/home/star.svg"
                  alt=""
                  width={13.5}
                  height={15}
                />
                <p className={styles.apiText}>{integrationReadyText}</p>
              </div>
              <h1>
                {h1Text}
                <br />
                <span className={styles.highlight}> {h1HighlightText} </span>
                {h1PoweredByText}
              </h1>

              <p>{descriptionText}</p>
              <div className={styles.actions}>
                <Button
                  type="default"
                  className={styles.playgroundButton}
                  onClick={() => router.push("/playground")}
                >
                  {playgroundButtonText}
                </Button>
                <StartBuildingButton />
              </div>
            </div>
          </div>

          <div className={styles.advantages}>
            <div className={styles.container}>
              <div className={styles.intro}>
                <p className={styles.subtitle}>{subtitleText}</p>
                <h2>{h2Text}</h2>
              </div>
              <div className={styles.grid}>
                <div className={styles.card}>
                  <h3>{advantage1Value}</h3>
                  <p>{advantage1Description}</p>
                </div>
                <div className={styles.card}>
                  <h3>{advantage2Value}</h3>
                  <p>{advantage2Description}</p>
                </div>
                <div className={styles.card}>
                  <h3>{advantage3Value}</h3>
                  <p>{advantage3Description}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Hero;
